import { useSubjectConfig, useAreaConfig } from '@/hooks';
import { useEffect, useState } from 'react';
import { LabelConfig } from '#server/models';
import { useViewerRouteParams, useViewerSearchParams } from '@/hooks';

export const LabelDetails = () => {
  const searchParams = useViewerSearchParams();
  const { viewerType, subjectSlug, areaSlug } = useViewerRouteParams();
  const [label, setLabel] = useState<LabelConfig | undefined>(undefined);

  const selectedLabelId = searchParams.selectedLabel;
  const { data: modelConfig } = useSubjectConfig(
    subjectSlug,
    viewerType,
    areaSlug
  );
  const { data: areaConfig } = useAreaConfig(areaSlug);
  const primaryCategoryGroup = areaConfig?.categoryGroups
    .find((gp) => gp.id === label?.primaryCategoryId.groupId);
  const primaryCategory = primaryCategoryGroup
    ?.categories.find((c) => c.id === label?.primaryCategoryId.id);

  useEffect(() => {
    const selectedLabel = modelConfig?.labels?.find((item) => item.slug === selectedLabelId);
    setLabel(selectedLabel);
  }, [selectedLabelId]);

  return (
    <>
      {label ? (
        <div className="flex flex-col gap-y-8 mt-8 p-4 text-base">
          <div>
            <div className="font-bold">{label.title}</div>
            <div className="mt-5">{label.description}</div>
          </div>
          <div>
            <div className="font-bold first-letter:uppercase">{areaConfig?.labelName?.singular} category</div>
            <div className="text-sm mt-5">
              <div
                className="inline-block rounded-2xl bg-black px-5 py-1 border-[3px]"
                style={{ borderColor: primaryCategory?.color }}
              >
                {primaryCategory?.name}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col mt-8 p-4 text-base font-normal">
          Please select a label or {areaConfig?.labelName?.singular} to view its details in this section.
        </div>
      )}
    </>
  );
};
